<template>
  <div>
    <fieldset>
      <h3 class="modal-title">CREATE APPLICATION</h3>
      <label class="f--14 m__l--12">Application Type</label>
      <div class="container-type-list-options-apps">
        <div
          :class="typeMode === 'native' ? 'option-active' : ''"
          class="container-option"
          @click="selectMode('native')">
          <img src="@/assets/icon/native.png">
          <span class="text-option">Native</span>
        </div>
        <div
          :class="typeMode === 'hyperlink' ? 'option-active' : ''"
          class="container-option"
          @click="selectMode('hyperlink')">
          <img src="@/assets/icon/hyperlink.png">
          <span class="text-option">Hyperlink</span>
        </div>
      </div>

      <b-row
        v-if="typeMode"
        class="p__l--10 p__r--10">
        <j-upload
          :accepted-file-type="['jpg', 'png', 'jpeg', 'bmp', 'xlsx', 'docx']"
          :api-token="token"
          :grid-cols="4"
          :label-name="'Icon'"
          :url-upload="url_upload"
          class="upload-blank-application"
          @url="getIcon"/>
        <b-col cols="8">
          <b-form-group :class="{'error-input' : $v.application.appName.$error}">
            <label for="appName"> Application Name </label>
            <j-input
              id="appName"
              v-model="$v.application.appName.$model"
              :error-required="false"
              placeholder="Enter application name here"/>
          </b-form-group>
          <b-form-group
            v-show="typeMode === 'hyperlink'"
            :class="{'error-input' : $v.application.appUrl.$error}">
            <label for="appUrl"> Url </label>
            <j-input
              id="appUrl"
              v-model="$v.application.appUrl.$model"
              :error-required="false"
              placeholder="Enter url"/>
          </b-form-group>
          <b-form-group :class="{'error-input' : $v.application.descName.$error}">
            <label for="descName"> Description </label>
            <j-textarea
              id="descName"
              v-model="$v.application.descName.$model"
              :error-required="false"
              :disabled="false"
              placeholder="Enter application description here"/>
          </b-form-group>
          <b-form-group>
            <label> Group Application </label>
            <j-single-select
              v-model="selectedGroup"
              :options="groupOptions"
              :placeholder="'Select Group'"
              :error-required="false"
              value-format="object"
            />
          </b-form-group>
          <b-form-group v-show="typeMode === 'native'">
            <label> Offline Mode </label>
            <j-toggle v-model="$v.application.is_offline_mode.$model"/>
          </b-form-group>
          <b-form-group v-show="typeMode === 'hyperlink'">
            <label> Open Hyperlink in App Browser (Mobile) </label>
            <j-toggle v-model="$v.application.open_hyperlink_in_app_browser.$model"/>
          </b-form-group>
          <b-form-group v-show="typeMode === 'hyperlink'">
            <label> Use Token </label>
            <j-toggle v-model="$v.application.useToken.$model"/>
          </b-form-group>
        </b-col>
      </b-row>

      <div class="pull-right">
        <b-button
          class="btn"
          @click="closeAppTypeModal">
          Close
        </b-button>
        <b-button
          :disabled="!typeMode"
          class="btn"
          variant="primary"
          @click="appType">
          Next
        </b-button>
      </div>
    </fieldset>
  </div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies, no-nested-ternary, max-len, no-unused-vars, no-console */
import { mapState, mapActions } from 'vuex';
import { required, requiredIf } from 'vuelidate/lib/validators';

import jUpload from '@/components/file-uploader/jUpload';

export default {
  components: {
    jUpload,
  },
  validations() {
    return {
      application: {
        appName: { required },
        appUrl: { required: requiredIf(() => this.typeMode === 'hyperlink') },
        descName: { required },
        is_offline_mode: {},
        open_hyperlink_in_app_browser: {},
        useToken: {},
      },
    };
  },
  data() {
    return {
      typeMode: '',
      urlIcon: null,
      token: JSON.parse(localStorage.getItem('Token')).value,
      application: {
        appName: null,
        appUrl: null,
        descName: null,
        is_offline_mode: false,
        open_hyperlink_in_app_browser: false,
        useToken: false,
      },
      selectedGroup: null,
      groupOptions: [],
    };
  },
  computed: {
    ...mapState('jStoreSetting', ['group_applications_list']),

    url_upload() {
      return `${process.env.GATE_URL}app/api/v3/pro/tool/uploadMedia`;
    },
  },
  watch: {
    group_applications_list(val) {
      this.groupOptions = [];
      val.forEach((lab) => {
        this.groupOptions.push({
          text: lab.name,
          id: lab.id,
          is_delete: false,
        });
      });
    },
  },
  created() {
  },
  methods: {
    ...mapActions('jStoreSetting', ['actionGetApplicationsList', 'actionCreateApplication', 'actionCreatePage', 'actionUpdatePage', 'actionDeletePage', 'actionGetGroupApplicationsList', 'actionGetListIcons']),

    closeAppTypeModal() {
      this.typeMode = '';
      this.$emit('modal-open', false);
    },
    async appType() {
      this.$v.application.$touch();

      if (!this.urlIcon) {
        this.$store.dispatch('jStoreNotificationScreen/toggleProblem', 'Icon is required');
      } else if (!this.$v.application.$error) {
        const text = this.typeMode === 'native' ?
          // eslint-disable-next-line
          `Offline Mode can't be updated after the application has successfully created` :
          '';
        const textMode = this.typeMode === 'native' ?
          (this.application.is_offline_mode ? 'with Offline Mode' : 'without Offline Mode') : '';
        this.$swal({
          title: `Are you sure to create application ${textMode}?`,
          text,
          showCancelButton: true,
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes',
        }).then(async (result) => {
          if (result.value) {
            const parameter = {
              name: this.application.appName,
              icon: this.urlIcon,
              icon_launcher: '-',
              description: this.application.descName,
              order: 0,
              type_platform: this.typeMode === 'hyperlink' ? (this.application.useToken ? 5 : 4) : 1,
              standalone_id: 0,
              hyperlink: this.typeMode === 'hyperlink' ? this.application.appUrl : '',
              group_application_id: this.selectedGroup ? this.selectedGroup.id : undefined,
              is_offline_mode: this.application.is_offline_mode,
              is_open_hyperlink_in_app_browser: this.application.open_hyperlink_in_app_browser,
            };
            const res = await this.actionCreateApplication(parameter);

            if (!res.error) {
              this.$router.replace(`/setting/application/${res.data.id}`);
            }
          }
        });
      }
      // this.$emit('type-mode', this.typeMode);
      // this.$emit('modal-open', false);
      // this.typeMode = '';
    },
    selectMode(val) {
      this.typeMode = val;
    },
    getIcon(data) {
      this.urlIcon = data;
    },
  },
};
</script>

<style lang="scss">
  .modal-app-type .modal-dialog {
    max-width: 600px !important;
  }
  .container-type-list-options-apps {
    display: flex;
    justify-content: left;
    margin: 5px 0 30px;
  }
  .container-option {
    border-radius: 8px;
    border: solid 1px #f3f3f3;
    padding: 20px;
    margin: 0 10px;
    min-width: 200px;
    text-align: center;

    .text-option {
      font-size: 18px;
      font-weight: bold;
    }

    &:hover{
      cursor: pointer;
      border: solid 1px #1a86e4;
    }
  }
  .option-active {
    background-color : #d8ecff;
  }
</style>



// WEBPACK FOOTER //
// src/views/setting/jModalAppType.vue